import { render, staticRenderFns } from "./DeveloperConfigMutant.vue?vue&type=template&id=a36a1874&scoped=true"
import script from "./DeveloperConfigMutant.vue?vue&type=script&lang=js"
export * from "./DeveloperConfigMutant.vue?vue&type=script&lang=js"
import style0 from "./DeveloperConfigMutant.vue?vue&type=style&index=0&id=a36a1874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a1874",
  null
  
)

export default component.exports